module.exports = __webpack_public_path__ + "img/share_room_link.2861247f.svg";